import { InboxIcon } from "@heroicons/react/24/outline";
import React from "react";
import { cn } from "@/core/utils/utils";
import { Card } from "./ui/card";
import { Stack } from "./ui/stack";
import { Typography } from "./ui/typography";

interface EmptyTableMessageProps {
  children?: React.ReactNode;
  className?: string;
}

export const EmptyTableMessage = ({
  children,
  className,
}: EmptyTableMessageProps) => (
  <Card
    className={cn(
      "flex h-[250px] w-full items-center justify-center border-2 border-dashed border-muted bg-background/50",
      className,
    )}
  >
    <Stack
      direction="column"
      gap="lg"
      align="center"
      justify="center"
      fullWidth
    >
      <InboxIcon className="h-16 w-16 text-tertiary-text" />
      {typeof children === "string" ? (
        <Typography variant="bodyW1" textColor="secondary">
          {children}
        </Typography>
      ) : (
        children
      )}
    </Stack>
  </Card>
);
